import { render, staticRenderFns } from "./MlbPlayerTrends.vue?vue&type=template&id=0982e726&scoped=true"
import script from "./MlbPlayerTrends.vue?vue&type=script&lang=js"
export * from "./MlbPlayerTrends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0982e726",
  null
  
)

export default component.exports